import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HKImmigrationPage = lazy(() => import('../pages/hk-immigration/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hk-immigration',
    element: <HKImmigrationPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
